import React from 'react';
import SidePanelBottomSection from '../SidePanelBottomSection';
import SidePanelTopSection from '../SidePanelTopSection';

import styles from '../../../../pages/ClubProfiles/club.scss';

const SidePanel = (props) => {
    const {
        auth,
        clubType,
        clubDetails,
        handleUploadPhoto,
        handleUploadLogoStart,
        removeSponsorLogo,
        sendMessage,
    } = props;

    return (
        <div className={`${styles.sidePanel}`}>
            <SidePanelTopSection
                auth={auth}
                clubType={clubType}
                clubDetails={clubDetails}
                handleUploadPhoto={handleUploadPhoto}
                handleUploadLogoStart={handleUploadLogoStart}
                removeSponsorLogo={removeSponsorLogo}
                sendMessage={sendMessage}
            />
            <SidePanelBottomSection
                clubDetails={clubDetails}
            />
        </div>
    );
};

export default SidePanel;
